/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  invoiceGridQuarter: [],
  checkDetails: [],
  viewCheckAllocationObj: {},
  viewCheckAllocationDetails: {},
  rowSelected: 0,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.VIEW_CHECK_ALLOCATION_TAB_DATA:
      return {
        ...state,
        viewCheckAllocationObj: action.viewCheckAllocationObj,
      };
    case actionTypes.VIEW_CHECK_ALLOCATION_DETAILS:
      return {
        ...state,
        viewCheckAllocationDetails: action.viewCheckAllocationDetails,
      };
       case actionTypes.ACTIVE_ROSI_PQAS_TAB_DETAILS:
          return{
            ...state,
            activeDetailScreenTabs:action.activeDetailScreenTabs
          };
    case actionTypes.GET_INVOICE_GRID:
      return { ...state, InvoiceList: action.invoiceGrid };
    case actionTypes.GET_QUARTER_GRID_DATA:
      const invoiceGridQuarterObj = action.invoiceGridQuarter;
      if (invoiceGridQuarterObj) {
        if (invoiceGridQuarterObj.length > 0) {
          invoiceGridQuarterObj.forEach((element) => {
            if (element.principalPaidAmt) {
              element.principalPaidAmt = element.principalPaidAmt
                ? handleCommaSeparatedAmount(element.principalPaidAmt)
                : `$ ${parseFloat(0).toFixed(2)}`;
            }
          });
        }
      }
      return { ...state, invoiceGridQuarter: invoiceGridQuarterObj };
    case actionTypes.ROW_SELECTED:
      return {
        ...state,
        rowSelected: action.rowSelected,
      };
    case actionTypes.CLEAR_REDUX:
      return [];
    default:
      return state;
  }
};

export default reducer;
